module.exports = __webpack_public_path__ + "static/media/creativ6.b42fbc04.jpg";